import { useState } from 'react';
import { phoneMask, stringDate, getFullName } from '../../../../util';
import moment from 'moment';
import { dateFormat } from '../../../../constants';
import { useSelector } from 'react-redux';
import { getSingleCustomers } from '../../../../appRedux/actions';
import {
  searchFilters,
  searchInputInitialValues,
  weMissYouFilter,
} from '../../../../constants/MembersConst';
import { ListTable, ModalView, TableFilters } from '../../../uiComponents';
import { useCustomModal } from '../../../../hooks/useCustomModal';
import { CustomerModal } from '../../Customer/CustomerModalBody';

export const WeMissYouTable = () => {
  const {
    privileges: { miss_you: privileges = [] },
  } = useSelector((state) => state.userAuth);

  const [dates, setDates] = useState({});
  const [modalTitle, setModalTitle] = useState(null);
  const [children, setChildren] = useState(null);
  const { modal } = useCustomModal();

  useState(() => {
    const startDate = moment().subtract(30, 'days').format(dateFormat);
    const endDate = moment().format(dateFormat);
    setDates({ startDate, endDate });
  });

  const getModal = (customer) => {
    modal();
    setModalTitle(getFullName(customer));
    setChildren(<CustomerModal data={customer} />);
  };

  const columns = [
    {
      title: 'ID de cliente',
      sorter: true,
      dataIndex: 'customerId',
      key: 'customerId',
      render: (id, customer) => (
        <button
          onClick={() => getModal(customer)}
          style={{
            background: 'none',
            border: 'none',
            color: '#1677ff',
            cursor: 'pointer',
            padding: 0,
          }}
        >
          {id}
        </button>
      ),
    },
    {
      title: 'Nombre',
      sorter: true,
      dataIndex: 'name',
      key: 'name',
      render: (name) => name?.toUpperCase(),
    },
    {
      title: 'Apellido Paterno',
      sorter: true,
      dataIndex: 'lastName',
      key: 'lastName',
      render: (lastName) => lastName?.toUpperCase(),
    },
    {
      title: 'Apellido Materno',
      sorter: true,
      dataIndex: 'motherLastName',
      key: 'motherLastName',
      render: (motherLastName) =>
        motherLastName?.toUpperCase() ? motherLastName?.toUpperCase() : '-',
    },
    {
      title: 'Género',
      sorter: true,
      dataIndex: 'gender',
      key: 'gender',
      render: (gender) => gender?.toUpperCase(),
    },
    {
      title: 'Correo',
      sorter: true,
      dataIndex: 'email',
      key: 'email',
      render: (email) => (email ? email : '-'),
    },
    {
      title: 'Celular',
      sorter: true,
      dataIndex: 'mobilePhone',
      key: 'mobilePhone',
      render: (mobilePhone) => phoneMask(mobilePhone),
    },
    {
      title: 'Última visita',
      dataIndex: 'appointments',
      key: 'appointments',
      render: (appointments) => {
        if (!appointments?.length) return '-';
        const lastAppointment = appointments[0];
        return stringDate(lastAppointment.date);
      },
    },
  ];

  return (
    <>
      <TableFilters
        privileges={privileges}
        params={{ dates }}
        searchFilters={searchFilters}
        filters={weMissYouFilter}
        searchInputInitialValues={searchInputInitialValues}
        blackListParam={true}
      />
      <ListTable
        columns={columns}
        getDataFunction={getSingleCustomers}
        params={{ needAppointment: true }}
        size="large"
        privileges={privileges}
      />
      <ModalView title={modalTitle} width={1500}>
        {children}
      </ModalView>
    </>
  );
};
